import { render, staticRenderFns } from "./ProductOnlineMedia.vue?vue&type=template&id=2774d29b&scoped=true&"
import script from "./ProductOnlineMedia.vue?vue&type=script&lang=js&"
export * from "./ProductOnlineMedia.vue?vue&type=script&lang=js&"
import style0 from "./ProductOnlineMedia.vue?vue&type=style&index=0&id=2774d29b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2774d29b",
  null
  
)

export default component.exports